<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container v-if="initDatas">
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="headTitle"
          ></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainTitle"></div>
          <el-tabs
            class="elTabs"
            v-model="activeName"
            @tab-click="handleClick"
            v-if="initDatas && flag"
          >
            <el-tab-pane label="问卷详情" name="0">
              <survey-info v-bind:survey_info="survey_info"></survey-info>
            </el-tab-pane>
            <el-tab-pane label="待审核" name="1" v-if="isHasAudit">
              <survey-audit v-bind:survey_info="survey_info"></survey-audit>
            </el-tab-pane>
            <el-tab-pane label="回收数据" name="2">
              <answer-list v-bind:survey_info="survey_info"></answer-list>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
    <answer-info></answer-info>
    <audit></audit>
  </div>
</template>

<script>
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";
import surveyInfo from "@/components/survey/surveyInfo";
import surveyAudit from "@/components/survey/surveyAudit";
import answerList from "@/components/survey/answerList";
import answerInfo from "@/components/survey/answerInfo";
import audit from "@/components/survey/audit";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    surveyInfo,
    surveyAudit,
    answerList,
    answerInfo,
    audit
  },

  data() {
    return {
      survey_info: "",
      meunItem: null,
      meunTitle: "",
      headTitle: "",
      activeName: "0",
      initDatas: false,
      isHasAudit: false,
      headTitle: "",
      survey_id: "",
      flag: false
    };
  },

  methods: {
    initData(meunItem) {
      this.flag = false;
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.initDatas = true;
      this.survey_id = localStorage.getItem("survey_id");
      this.getSurvey();
    },
    handleClick(tab, event) {},
    getSurvey() {
      this.$api
        .surveyInfo({
          token: localStorage.getItem("token"),
          survey_id: this.survey_id
        })
        .then(({ data }) => {
          this.$root.$emit("surveyInfo", data.Data);
          this.survey_info = data.Data;
          if (this.survey_info.is_audit == "N") {
            this.isHasAudit = false;
          } else {
            this.isHasAudit = true;
          }
          this.flag = true;
        })
        .catch(({ error }) => {});
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 50px;
  margin-top: -40px;
  margin-left: -20px;
  margin-right: -20px;
}
.elTabs {
  margin-top: -40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/survey.vue